__turbopack_context__.v({
  "copyRightContent": "footer-module-scss-module__xP4zMG__copyRightContent",
  "footer": "footer-module-scss-module__xP4zMG__footer",
  "footerWrapper": "footer-module-scss-module__xP4zMG__footerWrapper",
  "footerlinks": "footer-module-scss-module__xP4zMG__footerlinks",
  "footerlinksWrapper": "footer-module-scss-module__xP4zMG__footerlinksWrapper",
});
